// SPDX-FileCopyrightText: 2026 Ebiose AI
// SPDX-License-Identifier: LicenseRef-Ebiose-Proprietary
// All rights reserved. Confidential — unauthorized distribution prohibited.

export interface WidthColumn {
  id: string
  width?: number
}

export function normalizeWidths(
  columns: readonly WidthColumn[],
  visibleIds: readonly string[],
): Record<string, number> {
  const visible = new Set(visibleIds)
  const kept = columns.filter((column) => visible.has(column.id))

  const declaredTotal = kept.reduce((sum, column) => sum + (column.width ?? 0), 0)
  const undeclaredCount = kept.filter((column) => column.width === undefined).length
  const remainderShare =
    undeclaredCount === 0 ? 0 : Math.max(0, 1 - declaredTotal) / undeclaredCount

  const fractions = kept.map((column) => column.width ?? remainderShare)
  const fractionTotal = fractions.reduce((sum, fraction) => sum + fraction, 0)

  const result: Record<string, number> = {}
  kept.forEach((column, index) => {
    result[column.id] = fractionTotal === 0 ? 0 : (fractions[index] / fractionTotal) * 100
  })
  return result
}
